import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useEffect, useMemo } from 'react';
import { v4 } from 'uuid';
import { parseFiltersToQuery, getFilterValue, buildFilterArray } from './helper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@elliemae/ds-utilities/utils';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var noop = function noop() {
  return null;
};

function useFilterableState(grid) {
  var _grid$props = grid.props,
      filtersProp = _grid$props.filters,
      _grid$props$onAddFilt = _grid$props.onAddFilter,
      onAddFilter = _grid$props$onAddFilt === void 0 ? noop : _grid$props$onAddFilt,
      _grid$props$onRemoveF = _grid$props.onRemoveFilter,
      onRemoveFilter = _grid$props$onRemoveF === void 0 ? noop : _grid$props$onRemoveF,
      _grid$props$onRemoveA = _grid$props.onRemoveAllFilters,
      onRemoveAllFilters = _grid$props$onRemoveA === void 0 ? noop : _grid$props$onRemoveA,
      _grid$props$onFilters = _grid$props.onFiltersChange,
      onFiltersChange = _grid$props$onFilters === void 0 ? noop : _grid$props$onFilters;

  var _useState = useState(filtersProp || []),
      _useState2 = _slicedToArray(_useState, 2),
      filters = _useState2[0],
      setFilters = _useState2[1];

  useEffect(function () {
    if (filtersProp && filtersProp !== filters) {
      setFilters(filtersProp);
    }
  }, [filtersProp]);
  var queryFromFilters = useMemo(function () {
    return parseFiltersToQuery(filters || []);
  }, [filters]);

  var handleFiltersChange = function handleFiltersChange(nextFilters) {
    var _grid$getInstance = grid.getInstance(),
        body = _grid$getInstance.refs.body;

    body.current.scrollTop = 0;
    setFilters(nextFilters);
    grid.observeRows(function (rows) {
      return onFiltersChange(nextFilters, queryFromFilters, rows);
    });
  };

  var addFilter = function addFilter(filter, column) {
    var hasBeenCalled = false;

    var trimmedFilter = _objectSpread(_objectSpread({}, filter), {}, {
      value: String(filter.value).trim()
    });
    /* eslint-disable indent */


    var parsedFilter = !filter.group ? _objectSpread(_objectSpread({}, trimmedFilter), {}, {
      value: String(filter.value).trim(),
      group: 'all',
      label: 'All',
      id: v4()
    }) : _objectSpread(_objectSpread({}, trimmedFilter), {}, {
      value: String(filter.value).trim(),
      id: v4(),
      label: column && column.filterLabel || trimmedFilter.label,
      originalProperty: column.originalProperty || column.property,
      customValue: getFilterValue(trimmedFilter, column)
    });
    /* eslint-enable indent */

    setFilters(function (prevFilters) {
      // This was setted for an issue that was recalling this function on the handleFiltersChange
      if (hasBeenCalled) {
        return;
      }

      hasBeenCalled = true;
      var nextFilters = buildFilterArray(parsedFilter, prevFilters);
      handleFiltersChange(nextFilters);
      onAddFilter(parsedFilter, nextFilters, column);
    });
  };

  var removeFilter = function removeFilter(_ref) {
    var group = _ref.group,
        pill = _ref.pill,
        nextFilters = _ref.nextFilters;
    onRemoveFilter(group, pill.value, nextFilters);
    handleFiltersChange(nextFilters);
  };

  var removeAllFilters = function removeAllFilters() {
    onRemoveAllFilters();
    handleFiltersChange([]);
  };

  return {
    actions: {
      addFilter: addFilter,
      removeFilter: removeFilter,
      removeAllFilters: removeAllFilters
    },
    state: {
      query: queryFromFilters,
      filters: filters
    }
  };
}

export { useFilterableState };
//# sourceMappingURL=useFilterableState.js.map
